/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Max_Event_Lines_LabelInputs */

const en_style_guide_manager_max_event_lines_label = /** @type {(inputs: Style_Guide_Manager_Max_Event_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximum Event Lines`)
};

const fr_style_guide_manager_max_event_lines_label = /** @type {(inputs: Style_Guide_Manager_Max_Event_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lignes maximum par evenement`)
};

const de_style_guide_manager_max_event_lines_label = /** @type {(inputs: Style_Guide_Manager_Max_Event_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximale Ereignislinien`)
};

const it_style_guide_manager_max_event_lines_label = /** @type {(inputs: Style_Guide_Manager_Max_Event_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linee di eventi massimi`)
};

const ru_style_guide_manager_max_event_lines_label = /** @type {(inputs: Style_Guide_Manager_Max_Event_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Максимальное количество линий событий`)
};

const es_style_guide_manager_max_event_lines_label = /** @type {(inputs: Style_Guide_Manager_Max_Event_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máximas líneas de eventos`)
};

const zh_cn2_style_guide_manager_max_event_lines_label = /** @type {(inputs: Style_Guide_Manager_Max_Event_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大事件线`)
};

const ja_style_guide_manager_max_event_lines_label = /** @type {(inputs: Style_Guide_Manager_Max_Event_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大イベントライン`)
};

const hi_style_guide_manager_max_event_lines_label = /** @type {(inputs: Style_Guide_Manager_Max_Event_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अधिकतम घटना रेखाएँ`)
};

const pt_pt2_style_guide_manager_max_event_lines_label = /** @type {(inputs: Style_Guide_Manager_Max_Event_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número máximo de linhas de eventos`)
};

/**
* | output |
* | --- |
* | "Maximum Event Lines" |
*
* @param {Style_Guide_Manager_Max_Event_Lines_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_max_event_lines_label = /** @type {((inputs?: Style_Guide_Manager_Max_Event_Lines_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Max_Event_Lines_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_max_event_lines_label(inputs)
	if (locale === "de") return de_style_guide_manager_max_event_lines_label(inputs)
	if (locale === "it") return it_style_guide_manager_max_event_lines_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_max_event_lines_label(inputs)
	if (locale === "es") return es_style_guide_manager_max_event_lines_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_max_event_lines_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_max_event_lines_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_max_event_lines_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_max_event_lines_label(inputs)
	return en_style_guide_manager_max_event_lines_label(inputs)
});